import Color from 'color';
import { lFColor0, orange } from 'pages/components/LFHeader/LFHeader.styled';
import styled from 'styled-components';

/** Plain blue accents — not teal, and not the purple Save color. */
const rangeBlue = '#2563eb';
export const rangeBlueInk = Color(rangeBlue).darken(0.18).toString();
const rangeBlueSoft = Color(rangeBlue).alpha(0.1).toString();
const rangeBlueHover = Color(rangeBlue).alpha(0.16).toString();
const rangeBlueLine = Color(rangeBlue).alpha(0.4).toString();

export const Container = styled.div`
  background: white;
  padding: 20px 20px 18px;
  pointer-events: auto;
  width: 95vw;
  max-width: 400px;
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  color: #495057;
  box-shadow: 0 8px 28px rgba(33, 33, 55, 0.12);
`;

export const Header = styled.div`
  font-size: 17px;
  font-weight: 700;
  padding-top: 2px;
  padding-right: 28px;
  color: #212529;
  letter-spacing: -0.01em;
`;

export const Sub = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: #868e96;
  line-height: 1.45;
`;

export const EnableCard = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 16px;
  padding: 12px 12px;
  border: 1px solid #eceef2;
  border-radius: 10px;
  background: #fafbfc;
`;

export const RowLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #343a40;
  min-width: 0;
`;

export const ToggleGroup = styled.div`
  display: inline-flex;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  flex-shrink: 0;
  background: white;
`;

export const ToggleBtn = styled.button<{ $on?: boolean; $active?: boolean }>`
  border: none;
  background: ${({ $active, $on }) => {
    if (!$active) return 'transparent';
    return $on ? lFColor0 : '#e9ecef';
  }};
  color: ${({ $active, $on }) => {
    if (!$active) return '#868e96';
    return $on ? 'white' : '#495057';
  }};
  font-size: 12px;
  font-weight: 600;
  padding: 7px 14px;
  cursor: pointer;
  transition: background 120ms ease, color 120ms ease;
  &:hover {
    background: ${({ $active, $on }) => {
    if ($active && $on) return orange;
    if ($active) return '#dee2e6';
    return '#f1f3f5';
  }};
  }
`;

export const Fields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 14px;
`;

export const DateCard = styled.div`
  border: 1px solid #eceef2;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
`;

export const DateBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  border: none;
  background: transparent;
  padding: 12px 12px;
  cursor: pointer;
  text-align: left;
  &:hover {
    background: ${rangeBlueSoft};
  }
`;

export const DateMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const DateLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #868e96;
  letter-spacing: 0.3px;
  text-transform: uppercase;
`;

export const DateValue = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #212529;
`;

export const TimeBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 12px 12px;
  border-top: 1px solid #f1f3f5;
  margin-top: -2px;
  padding-top: 10px;
`;

export const TimeLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  color: #868e96;
`;

export const TimeInputs = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const TimeInput = styled.input`
  width: 42px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #fafbfc;
  color: #212529;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
  padding: 7px 4px;
  outline: none;
  font-family: inherit;
  &:focus {
    border-color: ${rangeBlueLine};
    background: white;
  }
`;

export const TimeSep = styled.span`
  color: #adb5bd;
  font-weight: 700;
  font-size: 13px;
  padding: 0 1px;
`;

export const TimeHint = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: #adb5bd;
  letter-spacing: 0.02em;
  margin-top: 2px;
`;

export const TimeToggle = styled.button<{ $open?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  margin-top: 10px;
  border: 1px dashed ${({ $open }) => ($open ? rangeBlueLine : '#dee2e6')};
  background: ${({ $open }) => ($open ? rangeBlueSoft : '#fff')};
  color: ${rangeBlueInk};
  font-size: 12px;
  font-weight: 600;
  padding: 9px 12px;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    border-color: ${rangeBlueLine};
    background: ${rangeBlueHover};
  }
`;

export const TimeToggleLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

export const MetricsBtn = styled.button`
  width: 100%;
  margin-top: 10px;
  border: none;
  background: ${rangeBlueSoft};
  color: ${rangeBlueInk};
  font-size: 13px;
  font-weight: 600;
  padding: 10px 12px;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: ${rangeBlueHover};
  }
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #f1f3f5;
`;

export const PrimaryBtn = styled.button`
  flex: none;
  width: auto;
  border: none;
  background: ${lFColor0};
  color: white;
  font-size: 13px;
  font-weight: 700;
  padding: 9px 16px;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: ${orange};
  }
`;

export const SecondaryBtn = styled.button`
  border: none;
  background: none;
  color: #6c757d;
  font-size: 13px;
  font-weight: 600;
  padding: 11px 12px;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    color: ${rangeBlueInk};
    background: ${rangeBlueSoft};
  }
`;

export const CalendarWrap = styled.div`
  margin-top: 2px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .react-calendar {
    width: 100%;
    border: 1px solid #eceef2;
    border-radius: 10px;
    padding: 6px 8px 8px;
  }

  /* Scope plain blue over the global purple calendar theme. */
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: ${rangeBlueSoft};
    color: ${rangeBlueInk};
  }

  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: ${rangeBlueSoft};
    color: ${rangeBlueInk};
  }

  .react-calendar__tile--now {
    box-shadow: inset 0 0 0 1.5px ${rangeBlueLine};
    color: ${rangeBlueInk};
  }

  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: ${rangeBlueSoft};
    box-shadow: inset 0 0 0 1.5px ${rangeBlueLine};
    color: ${rangeBlueInk};
  }

  .react-calendar__tile--hasActive {
    background: ${rangeBlueSoft};
    color: ${rangeBlueInk};
  }

  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: ${rangeBlueHover};
  }

  .react-calendar__tile--active {
    background: ${rangeBlueHover} !important;
    color: ${rangeBlueInk} !important;
  }

  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: ${rangeBlueLine} !important;
    color: ${rangeBlueInk} !important;
  }

  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: ${rangeBlueSoft};
  }
`;

export const CalendarTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #212137;
  margin-bottom: 10px;
  padding-right: 28px;
  letter-spacing: 0.01em;
`;

export const CalendarActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;
